export const CREAR_USER = "UPCUS";
export const EDITAR_USER = "UPEUS";
export const DESB_USER = "UPDUS";
export const UPDATE_CNTS_USER = "UPMCU";
export const ASIG_SERIE_OTRS = "UPASO";
export const CHANG_CONFI_USERS = "UPCCS";
export const CREAR_ROL = "UPCRS";
export const EDITAR_ROL = "UPERS";


export const GENERAR_CNTINGENCIA = "UPGCC";
export const EDITAR_FECHA = "UPMFC";
export const VER_SERIES_VENTA = "UPVSV";
export const EMISION_AUTO = "CEFAS";
export const CREAR_COPIAR_COMPRO = "UPCCC";
export const EMISION_COMPRO = "UPECS";
export const EDITAR_COMPRO = "UPECE";
export const EDITAR_PRECIO_VENTA = "UPEPV";
export const PUNTO_VENTA_COBRANZA = "UPRPV";
export const EMI_GUIA_AUTO = "CEGAG";
export const EDIT_COD_GUIA = "CRFPT";
export const VER_HISTORIAL_COTIZACION = "UPVCH";



export const VER_SERIES_LOG = "UPVTS";
export const APROBAR_REQUE = "UPROR";
export const CREAR_EDITAR_REQUE = "UPAOR";
export const APROBAR_OC = "UPROC";
export const CREAR_EDITAR_OC = "UPEOC";
export const APROBAR_OS = "UPAOS";
export const CREAR_EDITAR_OS = "UPCOS";
export const APROBAR_OP = "UPAOP";
export const CREAR_EDITAR_OP = "UPCAP";
export const APROBAR_CO = "UPACM";
export const CREAR_EDITAR_CO = "UPCEC";
export const CREAR_CARG_MASVA_I = "UPCAC";
export const CREAR_SAL = "UPCAS";
export const CREAR_ANULAR_TRA = "UPCAT";
export const APROBAR_ALL_TRA = "UPATT";
export const REF_TRA = "SOPRT";



export const VER_CAJA_COB = "UPRCC";
export const APER_CAJA_COB = "UPACO";
export const DEL_PAGO_REG = "UPEPR";
export const RE_PAGO_PROVE = "UPRPP";
export const REV_ALL_CAJA_CH = "UPRTC";
export const APER_CAJA_CH = "UPACC";

export const VER_ALL_CRDTO_ASE = "UPVCA";
export const GNR_COM_VENTA = "UPGCV";






